import { Button, colors } from '@mui/material';
import { Item } from './item-types';
import { useRouter } from 'next/router';
import { useP21UserContext } from '../../context/p21-user-context';
import { groups } from '../../constants/p21/role';

export default function ItemEditButton({ item }: { item: Item }) {
  const { isP21UserInGroup } = useP21UserContext();
  if (!isP21UserInGroup(groups.supplyChainVisible)) {
    return null;
  }
  const router = useRouter();
  const redirect = () => {
    router.replace(
      `/create-new-item?itemId=${item.item_id}&after=/item?itemId=${item.item_id}`,
    );
  };
  return (
    <>
      <Button variant='outlined' onClick={redirect}>
        Edit Item
      </Button>
    </>
  );
}
